export default __webpack_public_path__ + "components/page-header/static/snow-badge--dark-4e1620b7ada8abccc0ce667ee9bc9cbc.svg";